import { z } from 'zod'
import { AppKind, PushNotificationStatus, type ServerApp } from '../../models/App'
import { ServerAppSettingDTO, mapDTOToServerAppSetting, mapServerAppSettingToDTO } from './ServerAppSettingDTO'

const AppDeviceDTO = z.object({
  model: z.string()
})

export const ServerAppDTO = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  image_url: z.string().nullish(),
  type: z.enum([AppKind.Server]).nullish(),
  settings: ServerAppSettingDTO.nullish(),
  terminal: z.string().nullish(),
  device: AppDeviceDTO.nullish(),
  push_notification_status: z.nativeEnum(PushNotificationStatus).nullish(),
  was_base_product_auto_enabled_for_sale: z.boolean().optional()
})

export type ServerAppDTO = z.infer<typeof ServerAppDTO>

export function mapServerAppToDTO (model: ServerApp): ServerAppDTO {
  return {
    id: model.id,
    name: model.name,
    type: AppKind.Server,
    settings: mapServerAppSettingToDTO(model.settings),
    terminal: model.terminal ?? null,
    device: model.device ?? null,
    push_notification_status: model.pushNotificationStatus
  }
}

export function mapDTOToServerApp (dto: ServerAppDTO): ServerApp {
  return {
    id: dto.id ?? undefined,
    name: dto.name ?? '',
    kind: AppKind.Server,
    settings: dto.settings ? mapDTOToServerAppSetting(dto.settings) : { ip: '' },
    terminal: dto.terminal ?? undefined,
    device: dto.device
      ? {
          model: dto.device.model
        }
      : undefined,
    pushNotificationStatus: dto.push_notification_status ?? undefined
  }
}
